<mat-card appearance="outlined">
  @if (sections?.length) {
    <cotecna-nf-form
      #naturalForm
      [config]="naturalFormConfig"
      [sections]="sections"
      [controls]="controls"
      (formSubmitted)="onFormSubmitted($event)"
      (keypress)="ValidateKeyCode($event)"
      >
    </cotecna-nf-form>
  }
  <im-additional-fields-editable-mode [generalInfo]="generalInfo">
  </im-additional-fields-editable-mode>
  <mat-card-actions>
    <button (click)="cancel()" mat-stroked-button>CANCEL</button>
    <button
      [disabled]="!this.form?.isValid()"
      (click)="this.form?.submit()"
      mat-stroked-button
      color="primary"
      >
      SAVE
    </button>
  </mat-card-actions>
</mat-card>
